import axios from 'axios';

export const getLoanBankDetail = (body) => {
  // const body
  return axios.post('/services/calculateLoanBankRate', body)
}